// fields which will use a date input and must be converted
// to a date filter on the target list page interface
export const DATE_TYPE_COLS = {
    startDate: true,
    checkDate: true,
    endDate: true,
    quotationSignedMonth: true,
    initialQuotationDate: true,
}
